export default __webpack_public_path__ + "static/media/check-en-full.f94d2794.svg";